import { Component, OnDestroy, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { User } from '../../../account/user.models';
import { AppState } from '../../../store';
import { selectUser } from '../../../account/store/account.selectors';
// @ts-ignore
import image from '../../../../img/integrate_io_migration.png';
// @ts-ignore
import icon from '../../../../img/icon-arrow-right.svg';

@Component({
  selector: 'integrate-io-template',
  template: `
    <div class="dialog confirm text-center alert integrateio-notification">
      <div class="ticker-wrap">
        <div class="ticker">
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
          <div class="ticker__item">We're moving!</div>
        </div>
      </div>
      <img class="image" [src]="image" alt="Integrate.io" />
      <h2 class="title">
        Your Xplenty login is moving to
        <a class="link" href="https://www.integrate.io" target="_blank">integrate.io!</a>
      </h2>
      <div class="description">
        Please migrate your Xplenty account into the new Integrate.io Platform now. Your account won't change and
        <strong>It'll only take a few seconds!</strong>
      </div>
      <a [href]="link" class="migrate-button"> Migrate me! <img class="icon" [src]="icon" alt="icon" /></a>
      <div class="dialog-close" (click)="cancel()"></div>
    </div>
  `,
})
export class IntegrateioTemplateComponent implements OnDestroy {
  userSubscription: Subscription;
  link = '';
  image = image;
  icon = icon;

  constructor(
    private store: Store<AppState>,
    @Optional() public dialogRef: MatDialogRef<IntegrateioTemplateComponent>,
  ) {
    this.store.select(selectUser).subscribe((user) => {
      this.setLink(user);
    });
  }

  setLink(user: Partial<User>) {
    const url = `${process.env.INTEGRATEIO_URL}/auth/signup`;
    this.link = `${url}?email=${user.email || ''}&name=${user.name || ''}&product=xplenty`;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }
}
